import type {NotFoundPageProps} from './NotFoundPage';

export const mockNotFoundContent: NotFoundPageProps = {
  title: {
    data: {},
    content: [
      {
        data: {},
        content: [
          {
            data: {},
            marks: [],
            value: 'We can’t seem to find the page you’re looking for',
            nodeType: 'text',
          },
        ],
        nodeType: 'paragraph',
      },
    ],
    nodeType: 'document',
  },
  description: {
    data: {},
    content: [
      {
        data: {},
        content: [
          {
            data: {},
            marks: [],
            value:
              'This isn’t the page you’re looking for. We call that a 404 error in geek terms. We’ll be back just as soon as possible.',
            nodeType: 'text',
          },
        ],
        nodeType: 'paragraph',
      },
    ],
    nodeType: 'document',
  },
  banner: {
    title: 'Page Not Found Illustration',
    src: '//images.ctfassets.net/1fc9o8o7drlk/3KEBnMvCVKB5AM9g8TpkFz/9a43753b29876076795a83ca3cf536f7/robot.png',
  },
};
